import configs from "@/i18n/configs"
export default {
    'toggle-customer-account-status': 'تبديل حالة حساب زبون',
    'activated': 'تفعيل',
    'deactivated': 'إلغاء تفعيل',
    'the-selected-customer-is-account': 'هذا الحساب',
    'edit-doctor': `${configs.editDoctor.ar}`,
    'add-new-doctor': `${configs.addNewDoctor.ar}`,
    'contact-information': 'معلومات التواصل',
    'addresses': 'العناوين',
    'merge-customer': 'دمج الجهات',
    'do-you-want-to-merge-the-customer-with-another-customer': 'هل تريد دمج هذه الجهة مع جهة أخرى',
    'modification-requests': 'طلبات التعديل',
    'specializations': 'التخصصات',
    'classification': 'التصنيفات',
    'workload': 'التصنيف',
    'sort-by-name': 'ترتيب بحسب الاسم',
    'sort-by-classification': 'ترتيب بحسب التصنيف',
    titles: {
        doctors: `${configs.doctors.ar}`,
        pharmacies: `${configs.pharmacies.ar}`,
        centers: `${configs.centers.ar}`
    },
    labels: {
        doctor: `${configs.doctor.ar}`,
        pharmacy: `${configs.pharmacy.ar}`,
        center: `${configs.center.ar}`
    },
    'make-sure-you-have-entered-the-address-and-classification-please': 'تأكد من إدخال العنوان والتصنيف من فضلك',
    'delete-or-merge-customer': 'حذف أو دمج جهة',
    'add-location': 'إضافة موقع',
    'the-client-has-been-created': 'تم إنشاء الزبون بنجاح',
    'the-client-has-been-modified': 'تم تعديل الزبون بنجاح',
    'there-is-a-similarity-in-name-with-another-customer': 'هناك تشابه في الاسم مع زبون اخر',
    'active': 'فعال',
    'deactivate': 'غير فعال',
    'customers-types': 'أنواع الزبائن'
}